// extracted by mini-css-extract-plugin
module.exports = {"root":"_ee0561","spacerContainer":"_9eaeb3","heading":"_861233"};